<template>
  <div class="modal-overlay" v-if="isVisible" @click="cancel">
    <div class="modal-container" @click.stop>
      <div class="modal-content">
        <!-- Icon with background circle -->
        <div class="icon-wrapper">
          <div class="icon-circle">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="warning-icon">
              <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        
        <!-- Content -->
        <div class="modal-header">
          <h2>Recording in Progress</h2>
          <p>Your audio will be lost if you leave now. <br/> Please stop recording first to save your progress.</p>
        </div>
        
        <!-- Actions -->
        <div class="modal-actions">
          <button class="btn btn-secondary" @click="cancel">
            <span>Cancel</span>
          </button>
          <button class="btn btn-danger" @click="confirmLeave">
            <span>Leave Anyway</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
      leave_img: require('@/assets/images/home/icon_zhuyi.png'),
      isVisible: false
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    saveaudio() {
      this.$emit('saveaudio');
    },
    cancel() {
      this.$emit('cancel');
    },
    openModal() {
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
    },
    confirmLeave() {
      this.$emit('confirmLeave');
    },
  }
}
</script>

<style lang="less" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.modal-container {
  max-width: 580px;
  width: 90%;
  max-height: 90vh;
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.modal-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 24px;
  padding: 40px 32px 32px;
  box-shadow: 
    0 32px 64px rgba(0, 0, 0, 0.12),
    0 0 0 1px rgba(255, 255, 255, 0.8);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
  }
}

.icon-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.icon-circle {
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, #fef3c7 0%, #fcd34d 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    inset: -2px;
    background: linear-gradient(135deg, #f59e0b, #d97706);
    border-radius: 50%;
    z-index: -1;
    opacity: 0.2;
  }
  
  .warning-icon {
    width: 32px;
    height: 32px;
    color: #d97706;
  }
}

.modal-header {
  text-align: center;
  margin-bottom: 32px;
  
  h2 {
    font-size: 24px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 12px 0;
    letter-spacing: -0.025em;
    line-height: 1.2;
  }
  
  p {
    font-size: 16px;
    color: #6b7280;
    margin: 0;
    line-height: 1.5;
    font-weight: 400;
  }
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn {
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  padding: 14px 28px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    transition: left 0.5s;
  }
  
  &:hover::before {
    left: 100%;
  }
  
  span {
    position: relative;
    z-index: 1;
  }
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  box-shadow: 
    0 4px 14px rgba(59, 130, 246, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  
  &:hover {
    background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
    transform: translateY(-1px);
    box-shadow: 
      0 8px 25px rgba(59, 130, 246, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 
      0 4px 14px rgba(59, 130, 246, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }
}

.btn-secondary {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  color: #374151;
  box-shadow: 
    0 4px 14px rgba(107, 114, 128, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  
  &:hover {
    background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
    transform: translateY(-1px);
    box-shadow: 
      0 8px 25px rgba(107, 114, 128, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.8);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 
      0 4px 14px rgba(107, 114, 128, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.8);
  }
}

.btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  box-shadow: 
    0 4px 14px rgba(239, 68, 68, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  
  &:hover {
    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
    transform: translateY(-1px);
    box-shadow: 
      0 8px 25px rgba(239, 68, 68, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 
      0 4px 14px rgba(239, 68, 68, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(32px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

// Responsive design
@media (max-width: 640px) {
  .modal-content {
    padding: 32px 24px 24px;
    border-radius: 20px;
    margin: 20px;
  }
  
  .icon-circle {
    width: 64px;
    height: 64px;
    
    .warning-icon {
      width: 28px;
      height: 28px;
    }
  }
  
  .modal-header {
    h2 {
      font-size: 20px;
    }
    
    p {
      font-size: 14px;
    }
  }
  
  .btn {
    padding: 12px 24px;
    font-size: 14px;
    min-width: 120px;
  }
}

// Dark mode support (if needed)
@media (prefers-color-scheme: dark) {
  .modal-content {
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    box-shadow: 
      0 32px 64px rgba(0, 0, 0, 0.4),
      0 0 0 1px rgba(255, 255, 255, 0.1);
  }
  
  .modal-header {
    h2 {
      color: #f9fafb;
    }
    
    p {
      color: #9ca3af;
    }
  }
}
</style>